var StrategyResolver_1;
import * as tslib_1 from "tslib";
import { containerResolver } from '../protocol/resolver';
import { Strategy } from '../types';
export { Strategy };
let StrategyResolver = StrategyResolver_1 = class StrategyResolver {
    /**
     * Creates an instance of the StrategyResolver class.
     * @param strategy The type of resolution strategy.
     * @param state The state associated with the resolution strategy.
     */
    constructor(strategy, state) {
        this._resolved = false;
        this.strategy = strategy;
        this.state = this.originalState = state;
    }
    /**
     * Called by the container to allow custom resolution of dependencies for a function/class.
     * @param container The container to resolve from.
     * @param key The key that the resolver was registered as.
     * @return Returns the resolved object.
     */
    get(container, key) {
        switch (this.strategy) {
            case Strategy.Instance:
                return this.state;
            case Strategy.Singleton:
                if (this._resolved)
                    return this.state;
                const singleton = container.invokeWithKey(this.state, key);
                this.state = singleton;
                this._resolved = true;
                return singleton;
            case Strategy.Scoped:
                if (this._resolved)
                    return this.state;
                const scoped = container.invokeWithKey(this.state, key);
                this.state = scoped;
                this._resolved = true;
                return scoped;
            case Strategy.Transient:
                return container.invokeWithKey(this.state, key);
            case Strategy.Function:
                return this.state(container, key, this);
            case Strategy.Array:
                return this.state[0].get(container, key);
            case Strategy.Alias:
                return container.get(this.state);
            default:
                throw new Error('Invalid strategy: ' + this.strategy);
        }
    }
    clone() {
        return new StrategyResolver_1(this.strategy, this.originalState);
    }
};
StrategyResolver = StrategyResolver_1 = tslib_1.__decorate([
    containerResolver,
    tslib_1.__metadata("design:paramtypes", [Number, Object])
], StrategyResolver);
export { StrategyResolver };
//# sourceMappingURL=data:application/json;base64,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